import queryString from 'query-string';
import type { Router } from '@funtech-int/rival';

import { QueryParameter } from '@/shared/constants/queryParams';
import { removeQueryParamsFromUrl } from '@/shared/lib/navigation';

const FROM_WATCHING_QUERY_PARAMS = [
    QueryParameter.PROMO,
    QueryParameter.CONTINUE_WATCHING,
    QueryParameter.OPENED_CHANNEL_ID,
];

export const cleanQueryParamsOnStopPlayingContent = (router: Router) => {
    const browserSearch = window.location.search;

    if (!browserSearch) {
        return;
    }

    const currentQueryObject = queryString.parse(browserSearch);

    const filteredFromWatchingQueryParams = FROM_WATCHING_QUERY_PARAMS.filter(
        (param) => currentQueryObject[param]
    );

    const hasPlayingContentId = Boolean(currentQueryObject[QueryParameter.PLAYING_CONTENT_ID]);
    const hasOpenedChannelId = Boolean(currentQueryObject[QueryParameter.OPENED_CHANNEL_ID]);

    if (!hasPlayingContentId && !hasOpenedChannelId) {
        return;
    }

    const paramsToRemove = [
        QueryParameter.WATCH,
        QueryParameter.SEASON_NUMBER,
        QueryParameter.EPISODE_NUMBER,
        QueryParameter.PLAYING_CONTENT_ID,
        ...filteredFromWatchingQueryParams,
    ];

    if (filteredFromWatchingQueryParams.length > 0) {
        paramsToRemove.push(QueryParameter.REDIRECT_TO_FILM_PAGE);
    }

    removeQueryParamsFromUrl({ router, queryParams: paramsToRemove });
};
